import { useEffect, useRef } from 'react';

declare const __APP_BUILD_TIME__: string;

type VersionPayload = {
  buildTime?: string;
  commitSha?: string;
};

export default function AutoReloadOnNewBuild(props: { intervalMs?: number }) {
  const intervalMs = props.intervalMs ?? 60_000;
  const currentBuildTimeRef = useRef<string>(typeof __APP_BUILD_TIME__ === 'string' ? __APP_BUILD_TIME__ : '');

  useEffect(() => {
    let cancelled = false;
    let timer: number | null = null;

    const check = async () => {
      try {
        // Evitar caché a toda costa (navegador/CDN/proxy).
        const res = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store',
          headers: { 'cache-control': 'no-cache' }
        });
        if (!res.ok) return;
        const json = (await res.json()) as VersionPayload;
        const serverBuildTime = String(json?.buildTime ?? '').trim();

        if (!cancelled && serverBuildTime && serverBuildTime !== currentBuildTimeRef.current) {
          // Nueva versión desplegada: recargar para coger el index.html y assets nuevos.
          window.location.reload();
        }
      } catch {
        // Silenciar: si falla, reintentamos en el siguiente tick.
      }
    };

    // Primer check inmediato.
    void check();

    timer = window.setInterval(() => {
      void check();
    }, intervalMs);

    return () => {
      cancelled = true;
      if (timer !== null) window.clearInterval(timer);
    };
  }, [intervalMs]);

  return null;
}

